import { render, staticRenderFns } from "./GenAiTriagePanel.vue?vue&type=template&id=3bb7cbf6&scoped=true&"
import script from "./GenAiTriagePanel.vue?vue&type=script&lang=js&"
export * from "./GenAiTriagePanel.vue?vue&type=script&lang=js&"
import style0 from "./GenAiTriagePanel.vue?vue&type=style&index=0&id=3bb7cbf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7cbf6",
  null
  
)

export default component.exports